(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('EventDashboard', EventDashboard);

    EventDashboard.$inject = ['$resource', 'DateUtils'];

    function EventDashboard ($resource, DateUtils) {
        var resourceUrl = 'api/event-dashboards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'navbar': {
                method: 'GET',
                isArray: true,
                url: 'api/event-dashboards/navbar'
            },
            'viewData': {
                method: 'POST',
                url: 'api/event-dashboards/:id/view-data',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data && angular.isArray(data.events)) {
                        angular.forEach(data.events, normalizeEvent);
                    }
                    return data;
                }
            },
            'exportData': {
                method: 'POST',
                isArray: true,
                url: 'api/event-dashboards/:id/export-data',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (angular.isArray(data)) {
                        angular.forEach(data, normalizeEvent);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });

        function normalizeEvent(eventForm) {
            if (!eventForm) {
                return eventForm;
            }
            eventForm.dateRecord = DateUtils.convertDateTimeFromServer(eventForm.dateRecord);
            eventForm.statusChangedDate = DateUtils.convertDateTimeFromServer(eventForm.statusChangedDate);
            eventForm.createdDate = DateUtils.convertDateTimeFromServer(eventForm.createdDate);
            eventForm.lastModifiedDate = DateUtils.convertDateTimeFromServer(eventForm.lastModifiedDate);
            return eventForm;
        }
    }
})();
